import {
  CometChatMessageComposer,
  CometChatMessageHeader,
  CometChatMessageList,
  CometChatTextHighlightFormatter,
  CometChatUIKit,
  getLocalizedString,
  CometChatUserEvents,
  CometChatUIKitLoginListener,
  EnterKeyBehavior,
} from '@cometchat/chat-uikit-react';
import '../../styles/CometChatMessages/CometChatMessages.css';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { CometChat } from '@cometchat/chat-sdk-javascript';
import { useCometChatContext } from '../../context/CometChatContext';
import { AppContext } from '../../context/AppContext';
import { CometChatSettings } from '../../CometChatSettings';
import { ChatHistoryWithMessageInfo } from './ChatHistoryWithMessageInfo';
import { History } from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { COMETCHAT_CONSTANTS } from "../../../index";
import { SendHorizontal } from "lucide-react";
import { IoSend } from "react-icons/io5";
import { X } from "lucide-react";

const SendIcon = IoSend as unknown as React.FC<{
  size?: number;
  color?: string;
}>;

interface MessagesViewProps {
  user?: CometChat.User;
  group?: CometChat.Group;
  onHeaderClicked: () => void;
  onThreadRepliesClick: (message: CometChat.BaseMessage) => void;
  onSearchClicked?: () => void;
  showComposer?: boolean;
  onBack?: () => void;
  goToMessageId?: string;
  searchKeyword?: string;
  showGroupActionMessages?: boolean;
  loggedInUser?: string | undefined;
  conversationId?: string;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API_BASE_URL->", API_BASE_URL);

export const CometChatMessages = (props: MessagesViewProps) => {
  const { chatFeatures, callFeatures, layoutFeatures } = useCometChatContext();

  const [uploading, setUploading] = useState<string[]>([]);
  // Build mentionsUsersRequestBuilder for mentions in composer
  const mentionsUsersRequestBuilder = React.useMemo(() => {
    let builder = new CometChat.UsersRequestBuilder().setLimit(15);
    if (chatFeatures?.userManagement?.friendsOnly) {
      builder = builder.friendsOnly(true);
    }
    return builder;
  }, [chatFeatures?.userManagement?.friendsOnly]);

  const {
    user,
    group,
    onHeaderClicked,
    onThreadRepliesClick,
    showComposer,
    onBack = () => { },
    onSearchClicked = () => { },
    goToMessageId,
    searchKeyword,
    showGroupActionMessages,
    loggedInUser,
    conversationId
  } = props;;

  const [showComposerState, setShowComposerState] = useState<boolean | undefined>(showComposer);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { setAppState } = useContext(AppContext);

  const [apiMessages, setApiMessages] = useState<any[]>([]);
  const [loadingBackup, setLoadingBackup] = useState(false);
  const [showBackupModal, setShowBackupModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState<any>(null);

  const chatFeaturesRef = useRef(chatFeatures);
  const userRef = useRef(user);
  useEffect(() => {
    chatFeaturesRef.current = chatFeatures;
    if (
      (group && chatFeaturesRef.current && !chatFeaturesRef.current.deeperUserEngagement?.groupInfo) ||
      (user && chatFeaturesRef.current && !chatFeaturesRef.current.deeperUserEngagement?.userInfo)
    ) {
      setAppState({ type: 'updateSideComponent', payload: { visible: false, type: '' } });
    }

    const iframe = document.getElementById('cometchat-frame') as HTMLIFrameElement;
    const iframeDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
    const targetDiv =
      document.querySelector('.cometchat-messages-wrapper .cometchat-message-header .cometchat-list-item') ||
      iframeDoc?.querySelector('.cometchat-messages-wrapper .cometchat-message-header .cometchat-list-item');
    if (targetDiv) {
      if (
        (user && chatFeatures.deeperUserEngagement.userInfo) ||
        (group && chatFeatures.deeperUserEngagement.groupInfo)
      ) {
        (targetDiv as HTMLElement).style.cursor = 'pointer';
      } else {
        (targetDiv as HTMLElement).style.cursor = 'default';
      }
    }
  }, [chatFeatures, group, user, setAppState]);

  useEffect(() => {
    setShowComposerState(showComposer);
    if (user?.getHasBlockedMe?.()) {
      setShowComposerState(false);
    }
  }, [user, showComposer]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const fetchBackupMessages = async (userId: any, conversationId: any) => {
  //   try {
  //     setLoadingBackup(true);
  //     const res = await fetch(`http://localhost:5000/api/get-backup?userId=${encodeURIComponent(userId)}&conversationId=${conversationId}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //     });

  //     if (!res.ok) throw new Error("Failed to fetch backup");

  //     const data = await res.json();
  //     return data?.data || [];
  //   } catch (err) {
  //     console.error("Backup fetch failed:", err);
  //     setShowBackupModal(false);
  //     return [];
  //   } finally {
  //     setLoadingBackup(false);
  //   }
  // };

  // useEffect(() => {
  //   const loadBackup = async () => {
  //     if (user) {
  //       const messages = await fetchBackupMessages(loggedInUser, conversationId);
  //       setApiMessages(messages);
  //     } else if (group) {
  //       const messages = await fetchBackupMessages(loggedInUser, conversationId);
  //       setApiMessages(messages);
  //     }
  //   };

  //   loadBackup();
  // }, [user, group]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchBackupMessages = async (conversationId: string | undefined) => {
    if (!loggedInUser || !conversationId) return [];

    try {
      setLoadingBackup(true);
      const res = await fetch(
        `${API_BASE_URL}/get-backup?userId=${encodeURIComponent(
          loggedInUser
        )}&conversationId=${conversationId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!res.ok) throw new Error("Failed to fetch backup");

      const data = await res.json();
      return data?.data || [];
    } catch (err) {
      console.error("Backup fetch failed:", err);
      toast.error("Failed to load backup messages.");
      setShowBackupModal(false);
      return [];
    } finally {
      setLoadingBackup(false);
    }
  };

  const handleLoadBackup = async () => {
    let conversationToLoad;

    if (user) {
      conversationToLoad = conversationId; // user chat
    } else if (group) {
      conversationToLoad = conversationId; // group chat
    } else {
      toast.info("No conversation selected.");
      return;
    }

    const messages = await fetchBackupMessages(conversationToLoad);

    if (messages.length > 0) {
      setApiMessages(messages); // Update chat
    } else {
      setShowBackupModal(false);
    }
  };

  function getFormatters() {
    const formatters = CometChatUIKit.getDataSource().getAllTextFormatters({});

    if (searchKeyword) {
      formatters.push(new CometChatTextHighlightFormatter(searchKeyword));
    }
    return formatters;
  }

  const determineVideoCallVisibility = () => {
    if (group) {
      // Check group-specific video call permission
      return !callFeatures?.voiceAndVideoCalling?.groupVideoConference;
    } else if (user) {
      // Check one-on-one video call permission
      return !callFeatures?.voiceAndVideoCalling?.oneOnOneVideoCalling;
    }
    return true; // Default to hiding if neither user nor group
  };

  const determineVoiceCallVisibility = () => {
    if (group) {
      // Check group-specific voice call permission
      return !callFeatures?.voiceAndVideoCalling?.groupVoiceConference;
    } else if (user) {
      // Check one-on-one voice call permission
      return !callFeatures?.voiceAndVideoCalling?.oneOnOneVoiceCalling;
    }
    return true; // Default to hiding if neither user nor group
  };

  const determineUserOrGroupInfoVisibility = useCallback(() => {
    if (group) {
      return chatFeaturesRef.current && chatFeaturesRef.current.deeperUserEngagement?.groupInfo
        ? onHeaderClicked()
        : () => { };
    } else if (userRef) {
      return chatFeaturesRef.current && chatFeaturesRef.current.deeperUserEngagement?.userInfo
        ? onHeaderClicked()
        : () => { };
    }
  }, [group, onHeaderClicked]);

  const [messageListKey, setMessageListKey] = useState(0);

  // const AttachButton = () => {
  //   return (
  //     <button
  //       className="wa-attach-btn"
  //       onClick={() => {
  //         if (!user && !group) return;

  //         const input = document.createElement("input");
  //         input.type = "file";
  //         input.multiple = true;

  //         input.onchange = async (e: Event) => {
  //           const target = e.target as HTMLInputElement;
  //           if (!target.files?.length) return;

  //           const files = Array.from(target.files);
  //           target.value = "";

  //           const receiverId = group ? group.getGuid() : user!.getUid();
  //           const receiverType = group
  //             ? CometChat.RECEIVER_TYPE.GROUP
  //             : CometChat.RECEIVER_TYPE.USER;

  //           try {
  //             await Promise.all(
  //               files.map(async (file) => {
  //                 const tempId = `${file.name}-${Date.now()}-${Math.random()}`;
  //                 const mediaMessage = new CometChat.MediaMessage(
  //                   receiverId,
  //                   file,
  //                   CometChat.MESSAGE_TYPE.FILE,
  //                   receiverType
  //                 );
  //                 await CometChat.sendMediaMessage(mediaMessage);
  //                 // :white_tick: force message list to refresh
  //                 setMessageListKey((prev) => prev + 1);
  //                 // remove loader
  //                 setUploading((prev) => prev.filter((id) => id !== tempId));
  //                 // :white_tick: remove loader after success
  //                 setUploading((prev) => prev.filter((id) => id !== tempId));
  //               })
  //             );
  //           } catch (err) {
  //             console.error("Upload failed", err);
  //           }
  //         };
  //         input.click();
  //       }}
  //       aria-label="Attach"
  //     >
  //       {/* WhatsApp paperclip icon */}
  //       <svg
  //         width="22"
  //         height="22"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         stroke="currentColor"
  //         strokeWidth="1.8"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       >
  //         <path d="M21.44 11.05l-8.49 8.49a5 5 0 01-7.07-7.07l8.49-8.49a3.5 3.5 0 014.95 4.95l-8.49 8.49a2 2 0 01-2.83-2.83l7.78-7.78" />
  //       </svg>
  //     </button>

  //   );
  // };

  // const AttachButton = () => {
  //   return (
  //     <button
  //       className="wa-attach-btn"
  //       onClick={() => {
  //         if (!user && !group) return;

  //         const input = document.createElement("input");
  //         input.type = "file";
  //         input.multiple = true;

  //         input.onchange = async (e: Event) => {
  //           const target = e.target as HTMLInputElement;
  //           if (!target.files?.length) return;

  //           const files = Array.from(target.files);
  //           target.value = "";

  //           const receiverId = group ? group.getGuid() : user!.getUid();
  //           const receiverType = group
  //             ? CometChat.RECEIVER_TYPE.GROUP
  //             : CometChat.RECEIVER_TYPE.USER;

  //           try {
  //             await Promise.all(
  //               files.map(async (file) => {
  //                 const tempId = `${file.name}-${Date.now()}-${Math.random()}`;
  //                 const mediaMessage = new CometChat.MediaMessage(
  //                   receiverId,
  //                   file,
  //                   CometChat.MESSAGE_TYPE.FILE,
  //                   receiverType
  //                 );

  //                 // 🔥 Send file to CometChat
  //                 // const sentMessage =
  //                 //   await CometChat.sendMediaMessage(mediaMessage);

  //                 // // 🔥 Get uploaded file URL
  //                 // const fileUrl =
  //                 //   sentMessage.getAttachment()?.getUrl() || "";

  //                 let sentMessage =
  //                   await CometChat.sendMediaMessage(mediaMessage);
  //                 console.log("sentMessage->", sentMessage);

  //                 const message = sentMessage;   // ✅ it already is the message
  //                 const receiver = message.getReceiver();
  //                 const sentAt = message.getSentAt();

  //                 // 🔥 Safely extract file URL
  //                 let fileUrl = "";

  //                 if (sentMessage instanceof CometChat.MediaMessage) {
  //                   fileUrl = sentMessage.getAttachment()?.getUrl() || "";
  //                 }

  //                 if (receiverType === CometChat.RECEIVER_TYPE.USER) {

  //                   const response = await axios.get(
  //                     `${COMETCHAT_CONSTANTS.API_URL}/users/${receiverId}`,
  //                     {
  //                       headers: {
  //                         apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
  //                       },
  //                     }
  //                   );

  //                   const userData = response.data?.data;

  //                   const receiverName = userData?.name || "";
  //                   const receiverEmail =
  //                     userData?.metadata?.["@private"]?.email || "";

  //                   const loggedInUser = await CometChat.getLoggedinUser();
  //                   const senderName = loggedInUser?.getName() || "User";

  //                   const payload = {
  //                     sender_name: senderName,
  //                     receiver_name: receiverName,
  //                     receiver_email: receiverEmail,

  //                     type: "file",
  //                     attachments: [{ url: fileUrl }],

  //                     base_url: `${window.location.origin}/chats/user/${receiverId}`,
  //                     sent_at: sentAt
  //                   };

  //                   try {
  //                     const response = await axios.post(
  //                       `${API_BASE_URL}/send-chat-email`,
  //                       payload
  //                     );

  //                     console.log("Email API Success ->", response.data);
  //                   } catch (error: any) {
  //                     console.error("Email API Error ->", error);

  //                     if (error.response) {
  //                       console.error("Status ->", error.response.status);
  //                       console.error("Data ->", error.response.data);
  //                     }
  //                   }
  //                 } else if (receiverType === CometChat.RECEIVER_TYPE.GROUP) {

  //                   const groupId = receiverId;

  //                   // 🔥 Fetch group members
  //                   const membersResponse = await axios.get(
  //                     `${COMETCHAT_CONSTANTS.API_URL}/groups/${groupId}/members?perPage=1000&page=1`,
  //                     {
  //                       headers: {
  //                         apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
  //                       },
  //                     }
  //                   );

  //                   const members = membersResponse.data?.data || [];

  //                   // 🔥 Logged-in sender info
  //                   const loggedInUser = await CometChat.getLoggedinUser();
  //                   const senderName = loggedInUser?.getName() || "User";
  //                   const senderUid = loggedInUser?.getUid() || "";
  //                   const groupName = receiver.getName(); // 👈 Get group name here

  //                   // ❌ Remove sender
  //                   const filteredMembers = members.filter(
  //                     (member: any) => member.uid !== senderUid
  //                   );

  //                   // 📧 Extract emails
  //                   const emails = filteredMembers
  //                     .map((member: any) =>
  //                       member?.metadata?.["@private"]?.email || null
  //                     )
  //                     .filter(Boolean);

  //                   console.log("Group recipient emails ->", emails);

  //                   const receiverName = filteredMembers
  //                     .map((member: any) =>
  //                       member.name
  //                     )
  //                     .filter(Boolean);

  //                   console.log("Group recipient Attachment receiverName ->", receiverName);

  //                   // ======================================================
  //                   // 🚀 SEND EMAIL (FILE VERSION — same as your commented code)
  //                   // ======================================================

  //                   for (let i = 0; i < emails.length; i++) {
  //                     const email = emails[i];
  //                     const memberName = receiverName[i]; // pick the corresponding name

  //                     const payload = {
  //                       sender_name: senderName,
  //                       receiver_name: groupName, // ✅ single name
  //                       receiver_email: email,     // ✅ single email
  //                       type: "file",
  //                       attachments: [
  //                         {
  //                           url: fileUrl,
  //                         },
  //                       ],
  //                       base_url: `${window.location.origin}/chats/group/${groupId}`,
  //                       receiver_type: receiverType,
  //                       sent_at: sentAt
  //                     };

  //                     console.log("Group FILE Email Payload ->", payload);

  //                     try {
  //                       const response = await axios.post(
  //                         `${API_BASE_URL}/send-chat-email`,
  //                         payload
  //                       );
  //                       console.log("Email API Success ->", response.data);
  //                     } catch (error: any) {
  //                       console.error("Email API Error ->", error);
  //                       if (error.response) {
  //                         console.error("Status ->", error.response.status);
  //                         console.error("Data ->", error.response.data);
  //                       }
  //                     }
  //                   }
  //                 }

  //                 // ✅ Refresh messages
  //                 setMessageListKey((prev) => prev + 1);

  //                 // ✅ Remove loader
  //                 setUploading((prev) =>
  //                   prev.filter((id) => id !== tempId)
  //                 );
  //               })
  //             );
  //           } catch (err) {
  //             console.error("Upload failed", err);
  //           }
  //         };
  //         input.click();
  //       }}
  //       aria-label="Attach"
  //     >
  //       {/* Paperclip icon */}
  //       <svg
  //         width="22"
  //         height="22"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         stroke="currentColor"
  //         strokeWidth="1.8"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       >
  //         <path d="M21.44 11.05l-8.49 8.49a5 5 0 01-7.07-7.07l8.49-8.49a3.5 3.5 0 014.95 4.95l-8.49 8.49a2 2 0 01-2.83-2.83l7.78-7.78" />
  //       </svg>
  //     </button>
  //   );
  // };

  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [isDragging, setIsDragging] = useState(false);

  const [composerText, setComposerText] = useState("");

  useEffect(() => {
    if (pendingFiles.length > 0 && composerText === "") {
      setComposerText(" "); // single space enables button
    }

    if (pendingFiles.length === 0 && composerText === " ") {
      setComposerText("");
    }
  }, [pendingFiles]);

  const AttachButton = () => {
    return (<button
      className="wa-attach-btn"
      onClick={() => {
        if (!user && !group) return;

        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;

        input.onchange = (e: Event) => {
          const target = e.target as HTMLInputElement;
          if (!target.files?.length) return;

          // handleFilesUpload(Array.from(target.files));

          setPendingFiles((prev) => [
            ...prev,
            ...Array.from(target.files || [])
          ]);

          target.value = "";
        };

        input.click();
      }}
    >
      {/* Paperclip icon */}
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21.44 11.05l-8.49 8.49a5 5 0 01-7.07-7.07l8.49-8.49a3.5 3.5 0 014.95 4.95l-8.49 8.49a2 2 0 01-2.83-2.83l7.78-7.78" />
      </svg>
    </button>
    );
  };

  const handleFilesUpload = async (files: File[]) => {
    if (!user && !group) return;

    const receiverId = group ? group.getGuid() : user!.getUid();
    const receiverType = group
      ? CometChat.RECEIVER_TYPE.GROUP
      : CometChat.RECEIVER_TYPE.USER;

    try {
      await Promise.all(
        files.map(async (file, index) => {
          const tempId = `${file.name}-${Date.now()}-${Math.random()}`;

          // Optional loader start
          setUploading((prev) => [...prev, tempId]);

          const mediaMessage = new CometChat.MediaMessage(
            receiverId,
            file,
            CometChat.MESSAGE_TYPE.FILE,
            receiverType
          );

          // 🔥 Send file
          const sentMessage =
            await CometChat.sendMediaMessage(mediaMessage);

          console.log("sentMessage->", sentMessage);

          const receiver = sentMessage.getReceiver();
          const sentAt = sentMessage.getSentAt();

          // 🔥 Extract file URL safely
          let fileUrl = "";
          if (sentMessage instanceof CometChat.MediaMessage) {
            fileUrl = sentMessage.getAttachment()?.getUrl() || "";
          }

          const isLastFile = index === files.length - 1; // check if last file

          console.log("cometchat message isLastFile->", isLastFile);

          // ===============================
          // 👤 USER CHAT EMAIL LOGIC
          // ===============================
          if (receiverType === CometChat.RECEIVER_TYPE.USER) {

            const response = await axios.get(
              `${COMETCHAT_CONSTANTS.API_URL}/users/${receiverId}`,
              {
                headers: {
                  apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
                },
              }
            );

            const userData = response.data?.data;
            const receiverName = userData?.name || "";
            const receiverEmail =
              userData?.metadata?.["@private"]?.email || "";

            const loggedInUser = await CometChat.getLoggedinUser();
            const senderName = loggedInUser?.getName() || "User";

            const payload = {
              sender_name: senderName,
              receiver_name: receiverName,
              receiver_email: receiverEmail,
              type: "file",
              attachments: [{ url: fileUrl }],
              base_url: `${window.location.origin}/chats/user/${receiverId}`,
              sent_at: sentAt,
              message: isLastFile ? composerText.trim() : "" // only last file has composerText
            };

            try {
              const emailResponse = await axios.post(
                `${API_BASE_URL}/send-chat-email`,
                payload
              );
              console.log("Email API Success ->", emailResponse.data);
            } catch (error: any) {
              console.error("Email API Error ->", error);
            }
          }

          // ===============================
          // 👥 GROUP CHAT EMAIL LOGIC
          // ===============================
          else if (receiverType === CometChat.RECEIVER_TYPE.GROUP) {

            const groupId = receiverId;

            const membersResponse = await axios.get(
              `${COMETCHAT_CONSTANTS.API_URL}/groups/${groupId}/members?perPage=1000&page=1`,
              {
                headers: {
                  apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
                },
              }
            );

            const members = membersResponse.data?.data || [];

            const loggedInUser = await CometChat.getLoggedinUser();
            const senderName = loggedInUser?.getName() || "User";
            const senderUid = loggedInUser?.getUid() || "";
            const groupName = receiver.getName();

            const filteredMembers = members.filter(
              (member: any) => member.uid !== senderUid
            );

            const emails = filteredMembers
              .map((member: any) =>
                member?.metadata?.["@private"]?.email || null
              )
              .filter(Boolean);

            for (let i = 0; i < emails.length; i++) {
              const payload = {
                sender_name: senderName,
                receiver_name: groupName,
                receiver_email: emails[i],
                type: "file",
                attachments: [{ url: fileUrl }],
                base_url: `${window.location.origin}/chats/group/${groupId}`,
                receiver_type: receiverType,
                sent_at: sentAt,
                message: isLastFile ? composerText.trim() : "" // only last file has composerText
              };

              try {
                const emailResponse = await axios.post(
                  `${API_BASE_URL}/send-chat-email`,
                  payload
                );
                console.log("Email API Success ->", emailResponse.data);
              } catch (error: any) {
                console.error("Email API Error ->", error);
              }
            }
          }

          // // ✅ Refresh messages
          setMessageListKey((prev) => prev + 1);

          // ✅ Remove loader
          setUploading((prev) =>
            prev.filter((id) => id !== tempId)
          );
        })
      );
    } catch (err) {
      console.error("Upload failed", err);
    }
  };

  const HistoryButton = () => (
    <button
      className="backup-history-btn"
      onClick={() => {
        setShowBackupModal(true)
        handleLoadBackup();        // fetch backup for user or group
      }}
      title="View older messages"
    >
      {/* 🕘 */}
      <History />
    </button>
  );

  const getFileIcon = (fileName: any) => {
    const ext = fileName.split(".").pop().toLowerCase();

    const videoFormats = ["mp4", "mov", "avi", "mkv", "webm", "flv", "wmv", "m4v"];

    const audioFormats = ["mp3", "wav", "ogg", "flac", "aac", "m4a"];

    if (ext === "pdf") {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI/SURBVHgB1Ve/L2xBFP7m7L2bt7F5b98riO4hCgmFSkWEmmi1Qq3X06j8FXQWtR8lUWyIRiIhGiHBJn6sFXfGOWsb6y5zZ+9d8SWTmcyczPedM2fmngswjDH/uW1zuzXNwapwCreqDgrccmguitz6RcAqDyZqV83lJcz5OaKCenqAbNbWfEcEmA/k+/t4WVwEymVEBc3MIDU6CmQyNuZFCpsN8nkn8gqenqDZAZRKNtY5QhJgclsRyQiIICI5AZYiYhdgDg8RRYSHuAUcHOD6+Bjl9naklKp4KP2vkxNkp6aSFyDI8U24YRF3QQCPyT0ikO+H2jofgWppgRoYqLv+L53GXyYVchEhUQiDcwRofh7U2opgeRl6YyPU5rfnwdcaz9xiFyAR0Ht7APefIVONgKojwPkI9O4uSI7g6upLW1/yIG4Bpuq9OT21sld15t3fgYeHtw16e9EInAXQ2FjFe5qchOrogCvck7CvD8HCAtTICFJzczCcE1IHKL4ZenMTemvLah+nCBCTyhEoDr9qa4PhRCSuASQppZBJzc5a7xUpAnL1aHwcSsJ/dFQ5AsOeGhaj2XN5mFRnJ4KlJes9rQWIdzQ9/Xb/19cRrKy8W5comDoP0qf7WhtyWIVE7n0teSOwjoDmJ1cS7CVG8mgCHMJrg2Qrop8r4IsvXNwCirWT90NDKHE1Exdkr9vBwdA1+TPa5n64duHx4gLFQgFpavyU/K4u/OnuDlta+/afU+JK5UwG3PJoDoR4RziF+xXwDkgcKZ6uuwAAAABJRU5ErkJggg=="
          alt="PDF"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    if (ext === "txt") {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH5SURBVHgB3ZfLSxxBEMa/7s48FkIiG3LYJWxiSMwp5HHJNZBAcgrJHxrMHuJVbyJ7EEEEX+wDcdVdcPGgzmvHqlEPrqvMTPes4g+K7uluur6pLmp6ACKO41dk82SH8WSYZZ/sW1x0lsmmMFkGZJ9YwCx1fl+bHRzjoH+ErNRePIPrWmmXL7CAeHR0c3sPf+tLCMIIWfnx7QM+vn8J236UZvlAjhtdbGzkcs74foiNrW7SpmBKogCyiChEQBYRhQlIK8K4gFb7AFlEpErVLDQ7PbQ6u3j6xIEUEkLKpN3Z7eHn98/FC2BiWOjuH8H3TiClglQKyhrvqhABTKn0mN5cIQy9JAJSCGgLcB0LMzOVW9esb3bhnQZJ33FLkL7EcBhBCKkvgKlVy8mGzOvpCriMNptd+qoI/qphba1zZb1lO4iikKYNRODUC1Cfa2AYDZPnP7++0OYR6v8bEDh3kJy3urotP0tlKAeUssjO+5xgLMCy7BtDfMkNATBVBwTyYkRAfveGBMTIj6EjyC/hYeSATgS0SnGr3UvqvQ5aAlZW2wgCj+5/LvKidQRcXnWcawswwf0U4Do2JilgMDr47s1zSi4fpuC93k6Xx87xn9E8tV9HJ/r9Q7pcdKCkgi7VShm1WnXcVP3Of07pqiZa3CH7h8nAjhfYJ/s+A9xpLS5WrHVdAAAAAElFTkSuQmCC"
          alt="TXT"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    if (ext === "xlsx") {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMRSURBVHgBxVddSBRRFP5m9tfVQhLZqEzTJMkQwwQRIQt6kCiEtF4qeqkgo6B8KurBZ+mHIkoyzIcgsUzChDDcIMjC0MQty8RFDf9zU2TX/e3cu9vm/tU4u04fXGY4d+aeb875zrl3AILX682g0UljzqsMWphP5lvw3/TQSIaysNLYyQi00E156OzUzDxGx39EfTs1ZS2/Ts/OB9lzstYj0aCHRJgYAW+o9UO/BTfrX8LhcEV981bNUU7iyJnbEAQxYD9RWYLSohzo9VpIgFWMZG3r6P2rcwbL2Az6B0aQk2nE9uwNAbttyYlu+gC73QEJSFZDJmrvvYDb5UBz3QWehrNXGgORsNt9JHbtyPhnJGQT2L83HwaDDqa3n7CwsAivxw1B9SegUknIJlC2J49r4NDJaxDJsSiELyWFhGwCdx52wOm0oaa6Eja7C7V17dxuHviOooIsySRkE/g8NMGvudvSqGR/wuNxQRTV6P86hsHhERjXJUEQBXpC4NoYtozjWMXu+BG4er6cUrAGVZcewEVixLJiXnKK+DYyDZdziTsXRRU0msiuZBNITUniBCanrVBr9aSD4KW0ukTShQput5MiIQb1irgQqLrcwL/86f1qKsMFfxkKwYsTMcElUoV4wuZiJpCZboQhQQcz5Xxyas5fhuHLqdRa0oeb0hDnCFw8VcbLsOL0dbadUgo0UZ9lGhBoxJVA26te6HUicrM3kuh8rVkOZBNoN/Xx3DbdPQfzl1HU3GjlYlOMAFM1a71Nz7swMTVLWSANQEECv/GkvdsnwCg5XjUCxytKkJjga62LNgcam99ADmQTKMzLCJyKWCtueGwKa0arSoCh/lEHa/U4sK8QQb14BVi5apahu28YPeYxxALZEXjdNYDDB4uRZEjAu55B8FAoSaC57b1vFwRvhFCrJR1C40eA6g5qjeTjd1TEpIF4ICIBtsspScAaaiwuSOdH7niBrVWUnxZxjv0ZddK1NHRiYnIWH81DfCuNFVs2G7E1c1Okqdb//nMq0lHJwm5oPIMyYI5NzCfz/QsYRIzAPAyESAAAAABJRU5ErkJggg=="
          alt="XLSX"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    if (ext === "docx") {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAK7SURBVHgBzZdPTxNBGMafmd0thQoWo0SJiQjqAQSjJkSjiZoQTgb5BHoyxC/B1ZN+C08kolcvEKMSPYgtMRCkFQ0BMREahZb+m/F9t00jbUlmsC08yWQ3M7Pz/OZ98+7OAiStdRe1KWqbujGaZE/2FsWbWWphNFYJapcZYJJuRstHf2xofFvXsFXvGYnWFuPp0wxQ4fJ+XuHxsxzSWVjr0T2JoasuWpqMpidktd7nr9W+zFnJHd5AHsm00fSwRB2USptD1AXABqJuAKYQNQf4FNNWEC5qrMiSxuLXX+hsJ0fhQAhJzcHS92Y8HDlSfwBWKh/GwsoG8pk/ENL1m+cKGmkQAMsLHvONVS5VgqimugH4iwfaoKQHpbJ+Gv4LIBQsXLd37Pqk2wyhyEaKqusaV8HoTQdjd3cvMv7Axfh92plWpb6xERdDV9SueYKisFcKjAHm4hrXLzrklSn1dZ8COtpB7/1cqW+gW+Djwm+6K4PYw8oYIBpXlEeBjrAuGklEvqQRXUzj7EldBBJ0tsgjvqp9SxNZvYhmPlMUevkRuvYJvI2mMLcscaOfw6vQ0yl8KIfyXhcAjsKlHtcH4FBHY3nMLAj093BqNK71SR9KOgHjNS0joDBw3sOJthyUzmF9U2A7JegA4iHUlCU4hqLcC7PdWwNspYD4WqEiYis5KrFACWxsJICllSySGQ+m4bcGYHE1DA824d0/oWaA4cEg3kSS1OdZrWf9JmSz461ZRGJceoWdxtY0Xn3Ywcxcmuo9aLWeNUCMSuzpRJ7SHCKzAsA2pebJBJ3hdJAiYBfUfX0LpFN54pTS7BRa8RwOWIcTINSMhgIkyjvv9G/RQSKJWonXutW3WXWM/4ym6Hq7fGD1ZxKz8wk61tnVdTWdOx3Aha6j1YZeHvjPqaRP7DLfUHuBxoiNp9mTvf8CwVZ4KCLQmwsAAAAASUVORK5CYII="
          alt="DOCX"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    if (ext === "pptx") {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJHSURBVHgB1ZdNaxNBGMf/M7uTxHRTqx5K0EIR1HoSv4Dk4KWI4DfwI3jy4En0s4j0Vl8uHtQUvVVMD0HFolLEBg+NTRNtsuvujs/TFLTZFLOzL+I/DNl52fn/ZubZ2VmApLWep1SntK3z0TJ7srfYv1ijNIN81aF0kQGW6eJapLq7CbQ/IbaqF4DS9KStVxhAR4o3XgJPbgH+ALF16SawcBUolCdp3ZFji9fumZmzvF0awIvh/981I5GFYkBkAxADIjuACSHSB/jyCnEgbKQOsIrtz2/hOnOQUsASNEohUGy9R7l2IwcA0jH5Hd+2mugOQtgEoYhCKjW2bSYArONlm8xD9H8SBAFYBJIeAG80f8rr0c7ZArbWDxRPlyQURZkXgpYiTYDLt+Gu1xG6vb2sLFZgz56D1SaAZ3eA/XLWkYKEHehDw914CdzGfVit1xD08ynvqSlUri/BP3sFdnPpQFuOAZ3qEvCNNKU8ut/d0mPWasC1HEge8IjfISuQdB8Y6bVSRdDvIY6MZ0CdqUGcODnMFB3gdA3BVBX+h3qEKxOAwCEz5QwzFHTBu+foNx+jIn5A2pMTGAN4FITqa4OOVMM8P24lC3sbTxwZA5AXSrZAPLuojINQCIHk9oYA/ptHCAZdaGgkldES6Kd3UQg1hEo+A0YAigPASm7OyvZE9P8C0NstT4DOaOHO/CJ2+SWekriv9tzi2Dr+MqLNG7XITe1N7HxcRcFCYtmzCzh66vy4qof//OOUDqxigy8oPUA+YuMV9mTvX6exKJpgmkTmAAAAAElFTkSuQmCC"
          alt="PPTX"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    // VIDEO FILES
    if (videoFormats.includes(ext)) {
      return (
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI/SURBVHgB1ZfPaxNBFMe/O/tjdtc2JoKgBSXoqXrSk0ftxUNB1KP4H/iHqada0WtSClIVtDdpoYTQQtWqSbYlyf5Isr7ZiIcwxtnsbkq/8Nhlfuz77Hszb2cBUhzHVbI6WTuej9aET+Fb+3OzTVbGfNUhuyUA1ujm4WRv2xvh6NcQaXV1SYdjM9XhGwIgnmzdbUR4+baLaBAjrVbvubh9w4JlaSrDO1LUd5/8mZwLBWGMHXqBMFSaX1aOVVEQhQCkgSgMQBUid4DGfoQ0EAbyBjgYoLnfQnkxgqbp0BgDo+vBoYvVlQvFAwiNtBIOj9oIgmMwZiRmGPJtmToFly/qKJf+P812K7CdyhhANygS8ndNHYFH988lELX3Pupb/aljub0InZwPhxGlgeUD4PBxKFfu2EnFqxHE9pfwn+MN00mioDFd2p9pF4hUPKaIPHmwMDUtTDcTCCkgctDydZPsfJKWrc8+/ECy5bScFuE0ibQ8e1pK1oiqci9E3AJc3oPkIytVrnVgr9nDi9ffcNIzYAmSeQG0OhGer3+lKhgmW8/iJrUqnQeyAfT9ETY/tLD50cModuC4C7TW1BxnBhiH+zuOuwymWaJSO9ujUs96UzuB53l/w81t9XDnArDbGFJp5XAp3NBmdzwzgHCqG2orXEWFnojOLgDn2XObBqAz2XjzWoBB1EdeiuhZy9WutE/8GdXpeney48fPLnb22smBIquWLnFUr1RkXeun/nPKqHQ2xQ3ZK8xHwvGG8Cl8/waJH0DPGwrofQAAAABJRU5ErkJggg=="
          alt="VIDEO"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    // AUDIO FILES
    if (audioFormats.includes(ext)) {
      let audioIcon = "";

      if (ext === "ogg") {
        audioIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH6SURBVHgBxVfbasJAEJ3EeL8QURG8QB/EF5/6B/2E/mnbL9B3hf6B9s07jTdUUNM9SxMkTSCb3dgDQ5bdDedkZnZmQ8Rg2/YTsz6zb/sxeAMnuLXfwSczkx4Li9kzBLyxwat39Xw+0/F4JFEUi0VKJBJhtw8gwPbOWpZFk8mEbrcbiaLdblO1WiVd18Nst3x3LRaLSOTA9XrlHxDyfTOUzDhFxCJARERsAsKKUC5gt9uRiAiDYhAwn8/5Kbi3crlMnU4nfgFALpej7XZLh8OB1wTH/BCLAKBUKnFSFDQ8g+pCZAGmaXID4Pb1ev1nTz6f5+SXyyXQA5GSsNVqUbPZpOVyya1er1O32yWfokqZTIabshAgviAcDod0Op0omUzyTO/1enzNr38YhqFOAL5yOp3yBEPjATRNc9eC4OyRFoAv3Gw2lM1m3blGo8Hn0UMgKohMiQAglUq5Y+RDOp2m0WjEQyBCDkhVwkql4uYD4gwThZSAQqHA3Q7ce0UEUoVotVrRfr/nIYgKKQ8g3vBCFNc7kPIAcgA1AJUw5BVMrYDxeMxDAC9EhZQAVDc0HdGjdw/pC4kMuRIBsvAVIPBjoUSA5Z1E+8RFQhXQNYOOKv6M+uz54l3AlWo2m0mdcQdoULVazW/p499/TnWWxV8YMHunxwDEA3CC+wfREERCXNxfDQAAAABJRU5ErkJggg==";
      } else {
        // default audio icon for mp3, wav, flac, etc.
        audioIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI4SURBVHgBxVfPaxNBFP5msttkA8GkuYlo7MGbsj0JXvTsxSgeBIV48ij1L2h79CKIRw/BP0BTUeypZm96M6g9qKBREESsDUTT/NhkfLO20GQ3MNOdTT947GTeZL9v33vzdhYgCCFKZHWybTEb1CSn5Ga7gzdkecwWLbJFKaBGg/Kkd/TrC0Y/NqELvnAOPDuvutyTAsTkrP/+GTrVa0C/A11krj6AfbYClsmpLG/xqNn+y3sHIpcQvTY9wHOIbltleZ4jAeiISESAjojEBKiKMC5g+GEDOiIsGIb/cQNbnxsYFE+BM4YUQ2DOtwYKV+6aF2CfLmPwbm1s7oi/he2vr9AeEAFnZBRqay7y/7FSYJ0pw7lVC66TKGTI0gjILS7ApzDFEsCdPEa/m3BuVKn53Az5c/TQOVvAohRIMy5AYvD6EToPLyN9cRnZ23Wkjrljfsf6b4lEYA/DTx7+LJ9Ef30VmevVUEpsYrGTisB++CSk++QOCbgU8k3hN78NZTSYo/5mT6QT+m/XlNcm2opVoJUCls0jddQFl5XeoQNN8QT1WsSCsgBeLAXbjM+XxuZ7L1YRB8opmDu/FCI3AWUBYqcVOT/83sBMBPTWV9D37mO/IPlbp+KjoFWE3cdLlPOVoBgFFeG0qCQmQEKSmiDew6H3gWgBGq3UhIBQPLuLFez4MAZ5r7ZbifTJL6M6XS9MOv7+bKK16QXnubhIH3dRWHCjXE8P/eOUDq6sKQdk8Ta0HrEnOSX3PxBZPjDxF3YdAAAAAElFTkSuQmCC";
      }

      return (
        <img
          src={audioIcon}
          alt="AUDIO"
          className="cometchat-file-bubble__leading-view"
          height={24}
          width={24}
        />
      );
    }

    if (["doc", "docx", "xls", "ppt"].includes(ext)) {
      return <div className="cc-file-thumb">📄</div>;
    }

    return <div className="cc-file-thumb">📁</div>;
  };

  const truncateFileName = (name: any, maxLength = 10) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + "...";
  };

  const [loading, setLoading] = useState(false);

  const [loggedInUserRole, setLoggedInUserRole] = useState<CometChat.User | null>(null);
  // console.log("comectchat messages loggedInUserRole->", loggedInUserRole);

  useEffect(() => {
    const user = CometChatUIKitLoginListener.getLoggedInUser();
    setLoggedInUserRole(user);
  }, []);

  // Function to get role label
  const getRoleLabel = (role: string | undefined) => {
    switch (role) {
      case "manager":
        return "RA";
      case "lc":
        return "LC";
      default:
        return "Client";
    }
  };

  const role = user?.getRole();

  const displayName = (
    <div className="cometchat-list-item__body-title">
      {user?.getName()}
      {/* {role && <> ({getRoleLabel(role)})</>} */}
      {(loggedInUserRole?.getRole() === "manager" || loggedInUserRole?.getRole() === "lc") && role && <> ({getRoleLabel(role)})</>}
    </div>
  );

  const groupDisplayName = (
    <div className="cometchat-list-item__body-title">
      {group?.getName()}
    </div>
  );

  // If group exists show group name, else show user name
  const userGroupDisplayName = group ? groupDisplayName : displayName;

  const handleSendDirectMessage = async () => {
    if (!user && !group) return;
    if (!composerText.trim() && pendingFiles.length === 0) return; // nothing to send

    setLoading(true);

    try {
      const receiverId = group
        ? group.getGuid()
        : user!.getUid();

      const receiverType = group
        ? CometChat.RECEIVER_TYPE.GROUP
        : CometChat.RECEIVER_TYPE.USER;

      // if (composerText.trim()) {
      //   const textMessage = new CometChat.TextMessage(
      //     receiverId,
      //     composerText,
      //     receiverType
      //   );
      //   await CometChat.sendMessage(textMessage);
      // }

      if (pendingFiles.length > 0) {
        await handleFilesUpload(pendingFiles);
      }

      setComposerText("");
      setPendingFiles([]);
      // ✅ Refresh messages
      setMessageListKey((prev) => prev + 1);
    } finally {
      setLoading(false);
    }
  };

  const sendButtonView = (
    <div
      className={`cometchat-message-composer__send-button ${
        composerText.trim() || pendingFiles.length > 0
          ? "cometchat-message-composer__send-button-active"
          : ""
      }`}
    >
      <button
        className="cometchat-button"
        title="Send Message"
        disabled={!composerText.trim() && pendingFiles.length === 0}
        onClick={handleSendDirectMessage}
      >
        {loading ? (
          <span className="cometchat-button-spinner"></span>
        ) : (
          <SendIcon size={14} color="#ffffff" />
        )}
      </button>
    </div>
  );

  return (
    <div className="cometchat-messages-wrapper">
      <div
        className={`cometchat-header-wrapper 
          ${!layoutFeatures.withSideBar ? 'cometchat-header-wrapper__hide-back-button' : ''}
          ${!isMobile ? 'cometchat-header-wrapper__desktop' : ''}`}
      >
        <CometChatMessageHeader
          user={user}
          group={group}
          titleView={<>{userGroupDisplayName}</>}
          onBack={onBack}
          showBackButton={(layoutFeatures && layoutFeatures.withSideBar) || isMobile}
          showSearchOption={
            (chatFeatures && chatFeatures?.coreMessagingExperience?.conversationAndAdvancedSearch) ??
            //  CometChatSettings.chatFeatures.coreMessagingExperience.conversationAndAdvancedSearch
            true
          }
          onSearchOptionClicked={onSearchClicked}
          onItemClick={determineUserOrGroupInfoVisibility}
          // auxiliaryButtonView={<></>}
          auxiliaryButtonView={<HistoryButton />}
          // hideVideoCallButton={determineVideoCallVisibility()}
          // hideVoiceCallButton={determineVoiceCallVisibility()}
          hideVideoCallButton={true}
          hideVoiceCallButton={true}
          showConversationSummaryButton={
            (chatFeatures && chatFeatures?.aiUserCopilot?.conversationSummary) ??
            CometChatSettings.chatFeatures.aiUserCopilot.conversationSummary
          }
          hideUserStatus={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.userAndFriendsPresence) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.userAndFriendsPresence
          }
        />
      </div>
      <div className="cometchat-message-list-wrapper">
        {/* <BackupMessages messages={apiMessages} /> */}
        {/* {showBackupModal && (
          <ChatHistoryModal
            apiMessages={apiMessages}
            loggedInUid={loggedInUser || ""}
            onClose={() => setShowBackupModal(false)}
          />
        )} */}
        {showBackupModal && (
          <ChatHistoryWithMessageInfo
            apiMessages={apiMessages}
            loggedInUid={loggedInUser || ""}
            onClose={() => setShowBackupModal(false)}
          />
        )}
        <CometChatMessageList
          key={messageListKey}
          hideGroupActionMessages={showGroupActionMessages !== undefined ? !showGroupActionMessages : false}
          user={user}
          group={group}
          onThreadRepliesClick={(message: CometChat.BaseMessage) => onThreadRepliesClick(message)}
          goToMessageId={goToMessageId}
          textFormatters={searchKeyword && searchKeyword.trim() !== '' ? getFormatters() : undefined}
          showSmartReplies={
            (chatFeatures && chatFeatures?.aiUserCopilot?.smartReply) ??
            CometChatSettings.chatFeatures.aiUserCopilot.smartReply
          }
          showConversationStarters={
            (chatFeatures && chatFeatures?.aiUserCopilot?.conversationStarter) ??
            CometChatSettings.chatFeatures.aiUserCopilot.conversationStarter
          }
          smartRepliesDelayDuration={1000}
          hideReplyInThreadOption={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.threadConversationAndReplies) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.threadConversationAndReplies
          }
          hideTranslateMessageOption={
            (chatFeatures && !chatFeatures?.deeperUserEngagement?.messageTranslation) ??
            !CometChatSettings.chatFeatures.deeperUserEngagement.messageTranslation
          }
          hideEditMessageOption={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.editMessage) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.editMessage
          }
          hideDeleteMessageOption={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.deleteMessage) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.deleteMessage
          }
          hideReactionOption={
            (chatFeatures && !chatFeatures?.deeperUserEngagement?.reactions) ??
            !CometChatSettings.chatFeatures.deeperUserEngagement.reactions
          }
          hideMessagePrivatelyOption={
            (chatFeatures && !chatFeatures?.privateMessagingWithinGroups?.sendPrivateMessageToGroupMembers) ??
            !CometChatSettings.chatFeatures.privateMessagingWithinGroups.sendPrivateMessageToGroupMembers
          }
          hideReceipts={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.messageDeliveryAndReadReceipts) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.messageDeliveryAndReadReceipts
          }
          hideMessageInfoOption={
            (chatFeatures && !chatFeatures?.coreMessagingExperience?.messageDeliveryAndReadReceipts) ??
            !CometChatSettings.chatFeatures.coreMessagingExperience.messageDeliveryAndReadReceipts
          }
          hideModerationView={chatFeatures?.coreMessagingExperience?.moderation === false ? true : false}
          hideReplyOption={
            chatFeatures?.coreMessagingExperience?.quotedReplies === undefined
              ? true
              : !chatFeatures?.coreMessagingExperience?.quotedReplies
          }
          hideFlagMessageOption={
            chatFeatures?.moderatorControls.reportMessage === undefined
              ? false
              : !chatFeatures?.moderatorControls?.reportMessage
          }
        />
      </div>
      {showComposerState ? (
        // <div className="cometchat-composer-wrapper" ref={composerRef}>
        <div
          className={`cometchat-composer-wrapper ${isDragging ? "drag-active" : ""}`}
          onDragOverCapture={(e) => {
            e.preventDefault();
            setIsDragging(true);
          }}
          onDragLeaveCapture={() => {
            setIsDragging(false);
          }}
          onDropCapture={(e) => {
            e.preventDefault();
            setIsDragging(false);

            if (!user && !group) return;

            const files = Array.from(e.dataTransfer?.files || []);

            if (files.length > 0) {
              setPendingFiles((prev) => [...prev, ...files]);
            }
          }}
        >
          {pendingFiles.length > 0 && (
            <div className="preview-container">
              {pendingFiles.map((file, index) => {
                const previewUrl = URL.createObjectURL(file);
                console.log("file->", file);

                return (
                  <div key={index} className="preview-item">
                    {file.type.startsWith("image/") ? (
                      <img className="main-image-preview" src={previewUrl} alt="preview" />
                    ) : (
                      <div className="file-preview">
                        {getFileIcon(file.name)}
                        <span>{truncateFileName(file.name)}</span>
                      </div>
                    )}

                    <button
                      className="remove-btn"
                      onClick={() =>
                        setPendingFiles((prev) =>
                          prev.filter((_, i) => i !== index)
                        )
                      }
                    >
                      <X size={14} />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
          <CometChatMessageComposer
            mentionsUsersRequestBuilder={mentionsUsersRequestBuilder}
            user={user}
            group={group}
            disableMentions={
              (chatFeatures && !chatFeatures?.deeperUserEngagement?.mentions) ??
              !CometChatSettings.chatFeatures.deeperUserEngagement.mentions
            }
            disableMentionAll={
              chatFeatures?.deeperUserEngagement.mentionAll === undefined
                ? false
                : !chatFeatures?.deeperUserEngagement?.mentionAll
            }
            disableTypingEvents={
              (chatFeatures && !chatFeatures?.coreMessagingExperience?.typingIndicator) ??
              !CometChatSettings.chatFeatures.coreMessagingExperience.typingIndicator
            }
            hidePollsOption={
              (chatFeatures && !chatFeatures?.deeperUserEngagement?.polls) ??
              !CometChatSettings.chatFeatures.deeperUserEngagement.polls
            }
            hideCollaborativeDocumentOption={
              (chatFeatures && !chatFeatures?.deeperUserEngagement?.collaborativeDocument) ??
              !CometChatSettings.chatFeatures.deeperUserEngagement.collaborativeDocument
            }
            hideStickersButton={
              (chatFeatures && !chatFeatures?.deeperUserEngagement?.stickers) ??
              !CometChatSettings.chatFeatures.deeperUserEngagement.stickers
            }
            // hideEmojiKeyboardButton={
            //   (chatFeatures && !chatFeatures?.deeperUserEngagement?.emojis) ??
            //   !CometChatSettings.chatFeatures.deeperUserEngagement.emojis
            // }
            hideEmojiKeyboardButton={true}
            // hideVoiceRecordingButton={
            //   (chatFeatures && !chatFeatures?.deeperUserEngagement?.voiceNotes) ??
            //   !CometChatSettings.chatFeatures.deeperUserEngagement.voiceNotes
            // }
            hideVoiceRecordingButton={true}
            hideCollaborativeWhiteboardOption={
              (chatFeatures && !chatFeatures?.deeperUserEngagement?.collaborativeWhiteboard) ??
              !CometChatSettings.chatFeatures.deeperUserEngagement.collaborativeWhiteboard
            }
            // hideVideoAttachmentOption={
            //   (chatFeatures && !chatFeatures?.coreMessagingExperience?.videoSharing) ??
            //   !CometChatSettings.chatFeatures.coreMessagingExperience.videoSharing
            // }
            // hideFileAttachmentOption={
            //   (chatFeatures && !chatFeatures?.coreMessagingExperience?.fileSharing) ??
            //   !CometChatSettings.chatFeatures.coreMessagingExperience.fileSharing
            // }
            // hideAudioAttachmentOption={
            //   (chatFeatures && !chatFeatures?.coreMessagingExperience?.audioSharing) ??
            //   !CometChatSettings.chatFeatures.coreMessagingExperience.audioSharing
            // }
            // hideImageAttachmentOption={
            //   (chatFeatures && !chatFeatures?.coreMessagingExperience?.photosSharing) ??
            //   !CometChatSettings.chatFeatures.coreMessagingExperience.photosSharing
            // }

            hideFileAttachmentOption={true}
            hideImageAttachmentOption={true}
            hideVideoAttachmentOption={true}
            hideAudioAttachmentOption={true}
            onTextChange={(text) => {
              setComposerText(text);
            }}
            // enterKeyBehavior={EnterKeyBehavior.NewLine}
            // sendButtonView={
            //   <div
            //     className={`cometchat-message-composer__send-button ${composerText.trim() || pendingFiles.length > 0
            //       ? "cometchat-message-composer__send-button-active"
            //       : ""
            //       }`}
            //   >
            //     <button
            //       className="cometchat-button"
            //       title="Send Message"
            //       disabled={!composerText.trim() && pendingFiles.length === 0}
            //       onClick={async () => {
            //         if (!user && !group) return;

            //         setLoading(true);

            //         try {
            //           const receiverId = group
            //             ? group.getGuid()
            //             : user!.getUid();

            //           const receiverType = group
            //             ? CometChat.RECEIVER_TYPE.GROUP
            //             : CometChat.RECEIVER_TYPE.USER;

            //           if (composerText.trim()) {
            //             const textMessage = new CometChat.TextMessage(
            //               receiverId,
            //               composerText,
            //               receiverType
            //             );
            //             await CometChat.sendMessage(textMessage);
            //           }

            //           if (pendingFiles.length > 0) {
            //             await handleFilesUpload(pendingFiles);
            //           }

            //           setComposerText("");
            //           setPendingFiles([]);
            //         } finally {
            //           setLoading(false);
            //         }
            //       }}
            //     >
            //       {/* <SendIcon size={14} color="#ffffff" /> */}
            //       {loading ? (
            //         <span className="cometchat-button-spinner"></span>
            //       ) : (
            //         <SendIcon size={14} color="#ffffff" />
            //       )}
            //     </button>
            //   </div>
            // }
            // onSendButtonClick={
            //   pendingFiles?.length > 0 ? handleSendDirectMessage : undefined
            // }
            sendButtonView={sendButtonView}
            auxiliaryButtonView={<AttachButton />}
          />

        </div>
      ) : (
        <div
          className="message-composer-blocked"
          onClick={() => {
            if (user) {
              CometChat.unblockUsers([user?.getUid()]).then(() => {
                user.setBlockedByMe(false);
                CometChatUserEvents.ccUserUnblocked.next(user);
              });
            }
          }}
        >
          <div className="message-composer-blocked__text">
            {getLocalizedString('cannot_send_to_blocked_user')}{' '}
            <span className="message-composer-blocked__text-unblock"> {getLocalizedString('click_to_unblock')}</span>
          </div>
        </div>
      )}
    </div>
  );
};




